import React from 'react';

import { Checkbox } from 'semantic-ui-react';

export const STATUS_LOCK_KEY_NAME = 'statusLock';
export const STATUS_LOCK_ENABLED_LABEL = 'enabled';
export const STATUS_LOCK_DISABLED_LABEL = 'disabled';

class StatusLock extends React.Component {
  constructor(props) {
    super(props);

    this.handleStatusLockChange = this.handleStatusLockChange.bind(this);

    this.state = {
      enabled: false
    };
  }

  componentWillMount() {
    this.setState({
      enabled: this.isEnabled
    });
  }

  get label() {
    return localStorage.getItem(STATUS_LOCK_KEY_NAME);
  }

  get isEnabled() {
    return this.label === STATUS_LOCK_ENABLED_LABEL;
  }

  enableStatusLock() {
    localStorage.setItem(STATUS_LOCK_KEY_NAME, STATUS_LOCK_ENABLED_LABEL);
    this.setState({ enabled: true });
  }

  disableStatusLock() {
    localStorage.setItem(STATUS_LOCK_KEY_NAME, STATUS_LOCK_DISABLED_LABEL);
    this.setState({ enabled: false });
  }

  handleStatusLockChange(event, data) {
    if (data.checked) {
      this.enableStatusLock();
    } else {
      this.disableStatusLock();
    }
  }

  render() {
    return (
      <Checkbox
        toggle
        label="Status lock"
        checked={this.state.enabled}
        onChange={this.handleStatusLockChange}
      />
    );
  }
}

export default StatusLock;



// WEBPACK FOOTER //
// ./src/components/StatusLock.js